import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c35d8d64&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c35d8d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35d8d64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c35d8d64')) {
      api.createRecord('c35d8d64', component.options)
    } else {
      api.reload('c35d8d64', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c35d8d64&scoped=true&", function () {
      api.rerender('c35d8d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8FuLb7EL3yBka/JS/comp/SearchFilterTokens.vue"
export default component.exports